/* eslint-disable jsx-a11y/anchor-is-valid */

import { Calendly, TwitterButton, GumRoad } from './cta'
import { iData } from '../Utils/Types'
import React, { useState } from 'react'
import amplitude from 'amplitude-js'


export type TAB = 'KPI' | 'GROWTH' | 'HEATMAP'
interface iNavBar { data:iData, authenticated:boolean, oauthToken:string, click:(tab:TAB)=> void }
export const NavBar = ({ data, authenticated, oauthToken, click }: iNavBar) => {
    const [ isActive, setActive ] = useState(false)


    return <nav className="navbar is-black" role="navigation" aria-label="main navigation">
        <div className="navbar-brand" style={{ maxWidth:360, marginLeft:'auto' }}>
            <a className="navbar-item" href="https://branding.gq" rel="noopener noreferrer" target="_blank">
                <img src="SocialQ.png" style={{ height:36, maxHeight: 'none' }} alt={'SocialQ logo'}/>
                <p className="navbar-item" style={{ fontSize: '2em', color:'white' }} > SocialQ</p>
            </a>

            <a 
                role="button" 
                className={`navbar-burger ${isActive ? 'is-active': ''}`}
                aria-label="menu" 
                aria-expanded="false" 
                data-target="navbarBasicExample"
                onClick={()=> setActive(!isActive)}
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>

        <div className={`navbar-menu ${isActive ? 'is-active navbar-menu-active': ''}`} style={{ maxWidth:1200, marginRight:'auto' }}>
            <div className={`navbar-start ${isActive ? 'is-active navbar-start-active': ''}`}>
                <a 
                    className={`navbar-item ${isActive ? 'navbar-item-active': ''}`} 
                    onClick={() => {
                        amplitude.getInstance().logEvent('SWITCH_TAB', 'KPI')
                        isActive ? setActive(false) : setActive(isActive)
                        return click('KPI')
                    }}
                > KPIs </a>
                <a 
                    className={`navbar-item ${isActive ? 'navbar-item-active': ''}`} 
                    onClick={() => {
                        amplitude.getInstance().logEvent('SWITCH_TAB', 'GROWTH')
                        isActive ? setActive(false) : setActive(isActive)
                        return click('GROWTH')
                    }}
                > Growth </a>
                <a 
                    className={`navbar-item ${isActive ? 'navbar-item-active': ''}`} 
                    onClick={() => {
                        amplitude.getInstance().logEvent('SWITCH_TAB', 'HEATMAP')
                        isActive ? setActive(false) : setActive(isActive)
                        return click('HEATMAP')
                    }}
                > HeatMap </a>
            </div>

            <div className={`navbar-end ${isActive ? 'navbar-end-active': ''}`}>
                {   !authenticated 
                    ? 
                        <div className={`navbar-item ${isActive ? 'navbar-item-active': ''}`}>
                            <TwitterButton oauthToken={oauthToken}/> 
                        </div>
                    :   null 
                } { authenticated 
                    ? 
                        <div className={`navbar-item ${isActive ? 'navbar-item-active': ''}`}>
                            <Calendly /> 
                        </div>  
                    :   null 
                } { !data.paying || !authenticated
                    ?
                        <div className={`navbar-item ${isActive ? 'navbar-item-active': ''}`}>
                            <GumRoad/> 
                        </div>
                    :   null
                }
            </div>
        </div>
    </nav>
}
